import { Color } from 'lamina'
import * as THREE from 'three'
import {
  Material,
  Mesh,
  MeshBasicMaterial,
  MeshStandardMaterial,
  MeshToonMaterial,
  Object3D,
  Texture,
  Vector2,
} from 'three'
import StylizedStoneFloor from '../materials/StylizedStoneFloor'

const materials = new Map<string, MeshStandardMaterial | MeshBasicMaterial>()
// const materials = new Map<string, MeshToonMaterial>()
const textureLoader = new THREE.TextureLoader()
const gradientTexture = textureLoader.load(require('../textures/gradients/5.jpg'))
gradientTexture.minFilter = THREE.NearestFilter
gradientTexture.magFilter = THREE.NearestFilter
gradientTexture.generateMipmaps = false

const replaceStandardByToonMaterial = (obj: Object3D) => {
  obj.traverse((o: Object3D | Mesh) => {
    if (o.type === 'Mesh') {
      const mesh = o as Mesh
      const mat = mesh.material as MeshStandardMaterial
      if (!materials.has(mat.name)) {
        // console.log(mat.name, mesh)

        const newMat = new THREE.MeshLambertMaterial()// mat.clone()
        newMat.name = mat.name.split('.')[0]
        newMat.color = mat.color
        // newMat.metalness = 0
        // newMat.roughness = 1

        if (newMat.name === 'Stone') {
          newMat.color = new THREE.Color(0x035d66)
        }
        if (newMat.name === 'DarkWood') {
          newMat.color = new THREE.Color(0x035d66)
        }
        if (newMat.name === 'Mud') {
          // newMat.emissive = new THREE.Color(120, 120, 120)
          // newMat.map = StylizedStoneFloor.map!
          // newMat.aoMap = StylizedStoneFloor.aoMap!
          // newMat.displacementMap = StylizedStoneFloor.displacementMap!
          // newMat.normalMap = StylizedStoneFloor.normalMap!
          // newMat.roughnessMap = StylizedStoneFloor.roughnessMap!
          // newMat.color = new THREE.Color(0xc56dd4) // light violet
          // newMat.color = new THREE.Color(0xc00f89) // light scarlet
          // newMat.color = new THREE.Color(0x813581) // mid scarlet
          newMat.color = new THREE.Color(0x05a1a8)
          // newMat.metalness = 0
          // newMat.roughness = 1
          // newMat.displacementScale = 0
          // newMat.normalScale = new Vector2(1, 1)
          const repeatMap = (t: Texture) => {
            t.wrapS = THREE.RepeatWrapping
            t.wrapT = THREE.RepeatWrapping
            t.repeat.x = 6
            t.repeat.y = 6
          }
          // repeatMap(newMat.map)
          // repeatMap(newMat.aoMap)
          // repeatMap(newMat.displacementMap)
          // repeatMap(newMat.normalMap)
          // repeatMap(newMat.roughnessMap)
        }

        // const newMat = new MeshBasicMaterial({
        //   alphaMap: mat.alphaMap,
        //   aoMap: mat.aoMap,
        //   aoMapIntensity: mat.aoMapIntensity,
        //   color: mat.color,
        //   fog: mat.fog,
        //   lightMap: mat.lightMap,
        //   lightMapIntensity: mat.lightMapIntensity,
        //   map: mat.map,
        //   toneMapped: false
        // })

        // const newMat = new MeshToonMaterial({
        //   alphaMap: mat.alphaMap,
        //   aoMap: mat.aoMap,
        //   aoMapIntensity: mat.aoMapIntensity,
        //   bumpMap: mat.bumpMap,
        //   bumpScale: mat.bumpScale,
        //   color: mat.color,
        //   displacementMap: mat.displacementMap,
        //   displacementScale: mat.displacementScale,
        //   displacementBias: mat.displacementBias,
        //   emissive: mat.emissive,
        //   emissiveMap: mat.emissiveMap,
        //   emissiveIntensity: mat.emissiveIntensity,
        //   fog: mat.fog,
        //   gradientMap: gradientTexture,
        //   lightMap: mat.lightMap,
        //   lightMapIntensity: mat.lightMapIntensity,
        //   map: mat.map,
        //   normalMap: mat.normalMap,
        //   normalMapType: mat.normalMapType,
        //   normalScale: mat.normalScale,
        // })

        materials.set(mat.name, newMat)
      }
      mesh.material = materials.get(mat.name) as Material
    }
  })
}

export default replaceStandardByToonMaterial
